export default __webpack_public_path__ + "static/media/department.9d1f8f56.png";